import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UploadService } from 'src/app/core/services/upload.service';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent implements OnInit {

 file: File = null;
 imgBase64Path : string;
 loading : boolean = false;
 
 @Output() RetornoModal = new EventEmitter();
 @Input()  modalData : any;

 // Tipo de Archivo a Cargar
 // Valores Posibles
 //   M12ARC -> Fotografia del Estudiante, requiere como parámetro el M12CAR "{ \"M12CAR\":  \"01704878\"  }"
 
 constructor(
   private uploadService: UploadService) {
 }
 
 onFilechange(event: any) {
   console.log(event.target.files[0]);
   this.file = event.target.files[0];
   this.CreateBase64String();
 }
 
 upload() {
   if (this.file) {
    this.loading = true;
     this.uploadService.uploadfile(this.file, this.modalData.TABLA, this.modalData.PARAMETROS).subscribe(resp => {
       alert("Archivo Cargado");
       this.loading = false;
       this.RetornoModal.emit('REFRESH');
     })
   } else {
     alert("Debe seleccionar el archivo a cargar");
   }
 }

  ngOnInit(): void {
  }

    CreateBase64String() {
    if (this.file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const image = new Image();
        image.src = e.target.result;
        image.onload = rs => {
          this.imgBase64Path = e.target.result;
        };
      };
      reader.readAsDataURL(this.file);
    }
  }

}

 
 

